import { forwardRef } from 'react';

import type { DialogRef } from '@squire/ui';
import { Dialog, DialogBody, DialogContent, DialogOverlay } from '@squire/ui';

import { styles } from './styles';
import type { AlertDialogProps } from './types';

const AlertDialog = forwardRef<DialogRef, AlertDialogProps>(
  ({ children, ...props }, ref) => {
    return (
      <Dialog {...props} ref={ref}>
        <DialogContent animationType="fade" style={styles.content}>
          <DialogOverlay style={styles.overlay}>
            <DialogBody style={styles.body}>{children}</DialogBody>
          </DialogOverlay>
        </DialogContent>
      </Dialog>
    );
  },
);

AlertDialog.displayName = 'AlertDialog';
export { AlertDialog };
